import { render } from "./CalculateRiskProfileSection.vue?vue&type=template&id=2a5bbb9f"
import script from "./CalculateRiskProfileSection.vue?vue&type=script&lang=js"
export * from "./CalculateRiskProfileSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__